import styled, { useTheme } from 'styled-components';
import { FaHeart } from 'react-icons/fa'; // 아이콘 추가
import { useNavigate } from 'react-router-dom';
import { addCart, getCartList } from '../api/services/cartService';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from './ui';
import { setUserCartList } from '../redux/userCart';
import { addFavorites } from '../api/services/favoritesService';
import { useState } from 'react';
import { useGuestCheck } from '../hooks/useGuestCheck';

const ProductCardContainer = styled.div`
  display: flex;
  text-decoration: none;
  color: inherit;
  width: 12vw;
  border-radius: 5px;
  padding: 20px 30px;
  text-align: center;
  flex-direction: column;
  position: relative;
  transition: box-shadow 0.3s ease-in-out;

  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  /* Tablet responsive */
  @media (max-width: 768px) {
    width: 100%;
    padding: 15px 10px;
    box-sizing: border-box;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    width: 100%;
    min-width: 35vw;
    padding: 10px 8px;
    box-sizing: border-box;
  }

  /* Small mobile responsive */
  @media (max-width: 400px) {
    width: 100%;
    padding: 8px 6px;
    box-sizing: border-box;
  }

  /* Touch device fallback */
  @media (hover: none) and (pointer: coarse) {
    &:active {
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
    }
  }
`;

const ProductImagesWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 12vw;
  /* border: 1px solid #ddd; */
  object-fit: contain;
  background-color: #fff;

  /* Tablet responsive */
  @media (max-width: 768px) {
    height: 120px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    height: 100px;
  }

  /* Small mobile responsive */
  @media (max-width: 400px) {
    height: 80px;
  }
`;

const HoverButtons = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  gap: 8px;
  opacity: 0;
  visibility: hidden;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;

  ${ProductCardContainer}:hover & {
    opacity: 1;
    visibility: visible;
  }

  /* Hide on mobile devices */
  @media (max-width: 768px) {
    display: none;
  }
`;

const ProductName = styled.h3`
  font-size: 0.95rem;
  font-weight: 400;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  height: 2.4em;
  line-height: 1.2em;

  /* Tablet responsive */
  @media (max-width: 768px) {
    font-size: 0.9rem;
    height: 2.4em;
    line-height: 1.2em;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    font-size: 0.8rem;
    height: 2.2em;
    line-height: 1.1em;
  }
`;

const ProductDescr = styled.div`
  font-size: 0.9rem;
  margin: 10px 0 5px;
  height: 1rem;
  line-height: 0.9rem;
  color: #1e1e1e;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* ✅ 2줄에서 잘라냄 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  /* Tablet responsive */
  @media (max-width: 768px) {
    font-size: 0.8rem;
    height: 1.7rem;
    line-height: 0.85rem;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    font-size: 0.7rem;
    height: 1.5rem;
    line-height: 0.75rem;
  }
`;

const ProductCode = styled.span`
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e1e1e;
  margin-bottom: 2px;

  /* Tablet responsive */
  @media (max-width: 768px) {
    font-size: 0.75rem;
    margin-bottom: 4px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    font-size: 0.65rem;
    margin-bottom: 3px;
  }
`;

const StockInfo = styled.div`
  font-size: 0.85rem;
  color: ${(props) =>
    props.inStock
      ? props.theme.colors.primaryGreen
      : props.theme.colors.primaryRed};
  margin-bottom: 6px;

  /* Tablet responsive */
  @media (max-width: 768px) {
    font-size: 0.75rem;
    margin-bottom: 4px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    font-size: 0.65rem;
    margin-bottom: 3px;
  }
`;

const PriceInfo = styled.div`
  font-size: 0.85rem;
  color: #1e1e1e;
  margin-bottom: 4px;

  /* Tablet responsive */
  @media (max-width: 768px) {
    font-size: 0.75rem;
    margin-bottom: 3px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    font-size: 0.65rem;
    margin-bottom: 2px;
  }
`;

const UnitPrice = styled.div`
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 12px;

  /* Tablet responsive */
  @media (max-width: 768px) {
    font-size: 1rem;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-top: 8px;
    margin-bottom: 6px;
  }
`;

const AddToCartButton = styled.button`
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #2b2370;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    opacity: 0.6;
    &:hover {
      background-color: #cccccc;
    }
  }

  /* Tablet responsive */
  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 8px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    font-size: 0.7rem;
    padding: 6px;
  }
`;

const ActionButtons = styled.div`
  display: none;
  gap: 8px;
  align-items: center;
  justify-content: center;
  margin-top: 8px;

  /* Show only on mobile devices */
  @media (max-width: 768px) {
    display: flex;
    gap: 6px;
    margin-top: 6px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    gap: 4px;
    margin-top: 4px;
  }
`;

const IconButton = styled.button`
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 1);
  }

  /* Tablet responsive */
  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }

  /* Mobile responsive */
  @media (max-width: 480px) {
    width: 24px;
    height: 24px;
  }
`;

export default function ProductCard({ data, style }) {
  const userInfo = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const theme = useTheme();
  const { isGuestUser } = useGuestCheck();

  const {
    idStyle,
    webTitle,
    websitename,
    filepath1,
    avaQty,
    price,
    retailPrice,
    salePrice,
    image,
    color,
    qtyPerUOM,
    qtyPerCTN,
  } = data;

  const [useFallback, setUseFallback] = useState(false);

  // Dynamic URL based on error state and fallback
  const imgUrl = image
    ? image.replace(' copy', '').replace(' SAP', '')
    : useFallback || !filepath1
      ? `${process.env.REACT_APP_FILE_UPLOAD_URL}/style/${idStyle.replace(/\//g, '-')}.jpg`
      : `${process.env.REACT_APP_FILE_UPLOAD_URL}${filepath1.replace(' copy', '').replace(' SAP', '')}`;

  const handleImageError = () => {
    if (!useFallback && filepath1) {
      // First failure: try the fallback idStyle URL
      setUseFallback(true);
    }
    // If both URLs fail, the card will still show with a broken image icon
  };

  // Always render the card, even if images fail to load
  // The card will show with a broken image icon

  const inStock = avaQty > 0;

  const getDbCartList = async () => {
    if (userInfo.zipcode) {
      const result = await getCartList(
        userInfo.idCustomer,
        userInfo.zipcode,
        userInfo.idStore,
      );
      dispatch(setUserCartList({ cart_list: result.cartList }));
    }
  };

  const handleAddToCart = async (e) => {
    e.stopPropagation();

    if (!inStock) {
      return;
    }

    const result = await addCart(
      userInfo.idCustomer,
      idStyle,
      color,
      qtyPerUOM,
    );
    if (result.is_success) {
      getDbCartList();
      alert(`${websitename || webTitle} added to cart!`);
    } else {
      alert(`Error while add to cart`);
    }
  };

  const handleFavorites = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const result = await addFavorites(
      userInfo.idCustomer,
      idStyle,
      color,
      qtyPerUOM,
      userInfo.idStore,
    );
    if (result.is_success) {
      alert(`Added to favorites: ${websitename || webTitle}`);
    } else {
      alert(`Error while add to Favorites`);
    }
  };

  return (
    <ProductCardContainer
      onClick={() => {
        if (userInfo.userId != 0) {
          navigate(`/product?id=${idStyle}`);
        } else {
          navigate('/login');
        }
      }}
      style={style}
    >
      <ProductImagesWrapper>
        <ProductImage
          src={imgUrl}
          alt={`${websitename || webTitle}`}
          onError={handleImageError}
        />
        <HoverButtons>
          <IconButton onClick={handleFavorites}>
            <FaHeart size={16} color={theme.colors.primaryRed} />
          </IconButton>
        </HoverButtons>
      </ProductImagesWrapper>

      <ActionButtons>
        <IconButton onClick={handleFavorites}>
          <FaHeart size={16} color={theme.colors.primaryRed} />
        </IconButton>
      </ActionButtons>

      <ProductName>{websitename || webTitle}</ProductName>
      <ProductCode>{idStyle}</ProductCode>
      <ProductDescr>{`Pack : ${qtyPerUOM} / Carton : ${qtyPerCTN}`}</ProductDescr>
      <StockInfo inStock={inStock}>
        {inStock ? 'In Stock' : 'Out of stock'}
      </StockInfo>

      <PriceInfo>
        {userInfo.userId != 0 && retailPrice != null
          ? `Retail Price (SRP) : $${Number(retailPrice).toFixed(2)}`
          : ''}
      </PriceInfo>
      <UnitPrice>
        {userInfo.userId != 0 &&
        !isGuestUser &&
        price != null &&
        salePrice != null
          ? `Your Price: $${(Number(price) - Number(salePrice)).toFixed(2)}`
          : ''}
      </UnitPrice>
      {userInfo.userId != 0 ? (
        isGuestUser ? (
          <AddToCartButton disabled style={{ opacity: 0.5 }}>
            GUEST - CART DISABLED
          </AddToCartButton>
        ) : (
          <AddToCartButton onClick={handleAddToCart} disabled={!inStock}>
            ADD TO CART
          </AddToCartButton>
        )
      ) : (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            navigate('/login');
          }}
        >
          Login to see price
        </Button>
      )}
    </ProductCardContainer>
  );
}
